module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="photo_caption_row">\n	<div class="image_container" id="' +
((__t = ( getUniqueId() )) == null ? '' : __t) +
'">\n		';
 if (isVid()) { ;
__p += '\n		<video class="image_holder" src="' +
((__t = ( dataUrl )) == null ? '' : __t) +
'"></video>\n		';
 } else { ;
__p += '\n		<div class="image_holder" style="background-image: url(' +
((__t = ( thumbnailUrl() )) == null ? '' : __t) +
');"></div>\n		';
 } ;
__p += '\n	</div>\n\n	<textarea class="caption ' +
((__t = ( addClassIfTrue(requiredCaptions(), 'required') )) == null ? '' : __t) +
'" placeholder="' +
((__t = ( isDefaultCaptionPlaceholder() ? I18n.t('uploader.review_submission.caption_placeholder') : captionPlaceholder() )) == null ? '' : __t) +
'">' +
((__t = ( getCaption() )) == null ? '' : __t) +
'</textarea>\n	<div class="required_error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n	<i class="fa-light fa-trash delete_content" aria-label="' +
((__t = ( I18n.t('uploader.review_submission.delete_content') )) == null ? '' : __t) +
'"></i>\n</div>\n\n<div class="photo_bottom_row">\n	<div class="photo_actions">\n		';
 if (productFieldEnabled() && searchMode !== 'hidden') { ;
__p += '\n			<button class="product_tag_button">\n				<i class="fa-light fa-tag"></i>\n				' +
((__t = ( I18n.t('uploader.review_submission.product_tagging_button') )) == null ? '' : __t) +
'\n			</button>\n		';
 } else { ;
__p += '\n			<div></div>\n		';
 } ;
__p += '\n	</div>\n  ';
 if (hasProducts) { ;
__p += '\n		<p class="tagged_products_title">' +
((__t = ( I18n.t('uploader.review_submission.tagged_products') )) == null ? '' : __t) +
'</p>\n		<div class="product_list"></div>\n	';
 } ;
__p += '\n</div>\n';

}
return __p
}